<template>
  <div class="bg-secondary-3">
    <div class="py-1 px-4 rounded">
      <div class="row mt-4">
        <div class="col-12 d-flex">
          <i class="fas fa-copy text-orange mr-2 mt-1"></i>
          <p class="font-weight-normal font-18">
            Enmendar
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <ValidationObserver ref="academicProgramAmend">
            <div class="main-content mt-2">
              <div class="mb-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="reason"
                  rules="required"
                >
                  <custom-text-area
                    v-model="reason"
                    required
                    :maxlength="3000"
                    label="Razón de Enmienda:"
                    :error="errors[0]"
                    :custom-error-msg="'La razón de enmienda es requerida'"
                    show-char-count
                    :count-classes="['d-block', 'small-counter', 'text-right']"
                  />
                </ValidationProvider>
              </div>
              <div class="d-flex justify-content-end align-items-center px-0">
                <action-button
                  type="button"
                  text="Cancelar"
                  i="fa fa-times-circle"
                  variant="outline-danger"
                  class="ml-2 px-4 mb-3 actionButton"
                  @click="close()"
                />

                <action-button
                  type="button"
                  text="Guardar"
                  i="fas fa-save"
                  variant="success"
                  class="ml-2 px-4 mb-3 actionButton"
                  @click="save()"
                />
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import peiService from "@/services/pei/peiAcademicProgressCalendar.js";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";
import alert from "@/mixin/alert.mixin";

export default {
  name: "AcademicProgressAmend",
  components: {
    ValidationProvider,
    ValidationObserver,
    CustomTextArea,
    ActionButton
  },
  data: () => ({
    reason: null
  }),
  mixins: [alert],
  mounted() {},
  props: {
    academicProgressId: {
      type: Number,
      default: null,
      require: true
    }
  },
  methods: {
    async save() {
      const isValid = await this.$refs.academicProgramAmend.validate();

      if (!isValid) {
        this.ShowToast(
          "Error",
          "Favor de completar la información solicitada.",
          "error"
        );
        return;
      }

      const model = {
        id: this.academicProgressId,
        reason: this.reason
      };
      await peiService.saveAmed(model).then(
        () => {
          this.ShowToast(
            "Proceso exitoso.",
            "La enmienda se ha guardado correctamente.",
            "success"
          );
          this.reason = null;
          this.$emit("saved");
        },
        error => {
          this.ShowToast("Alerta", `${error.response.data.message}.`, "error");
          return { data: false };
        }
      );
    },
    async close() {
      this.reason = null;
      this.$emit("cancel");
    }
  }
};
</script>

<style lang="scss" scoped></style>
